import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import ViewToggle from "../../../../Components/Utils/ViewToggle";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { useFormik } from "formik";
import * as yup from 'yup';
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import PremiumTable from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import moment from "moment";
import ModalContainer from "../../../../Components/Others/ModalContainer";

// Appointments Table Row Component
const AppoinmentTableRow = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const formattedReminder = row.reminder ? moment(row.reminder).format("DD-MMM-YYYY hh:mm A") : "--";
  const handle = async () => handleDelete("appointments/" + `${row.appointmentId}`, setIsModalOpen);

  return (
    <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
      {/* ID */}
      <td className="p-4 text-center align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl text-xs font-semibold text-gray-500">
        {row.appointmentId}
      </td>

      {/* Title */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800">
        <Link
          to={`/marketing/appointments/view/${row.appointmentId}`}
          state={{ data: row, pageIndex, searchQuery }}
          className="hover:underline text-sm font-bold text-gray-800"
        >
          {row.title || "N/A"}
        </Link>
      </td>

      {/* Industry */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100">
          {row.industry || "N/A"}
        </span>
      </td>

      {/* Visit Purpose */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600">
        {row.visitPurpose || "N/A"}
      </td>

      {/* Reminder */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-500 whitespace-nowrap">
        {formattedReminder}
      </td>

      {/* Status */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Completed" || row.status === "Approved"
          ? "bg-emerald-50 text-emerald-700 border-emerald-100"
          : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
          }`}>
          {row.status || "N/A"}
        </span>
      </td>

      {/* Action Buttons */}
      <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
        <div className="flex items-center justify-center gap-1.5">
          {/* View */}
          <Link
            to={`/marketing/appointments/view/${row.appointmentId}`}
            state={{ data: row, pageIndex, searchQuery }}
            className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
            title="View details"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </Link>
          {/* Edit */}
          {CheckEditAction(row, "Appoinment", canEdit) && (
            <Link
              to={`/marketing/appointments/edit/${row.appointmentId}`}
              state={{ data: row, from: "/marketing/appointments", pageIndex, searchQuery }}
              className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Edit appointment"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </Link>
          )}
          {/* Delete */}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => {
                setIsModalOpen(true);
              }}
              // onClick={() => handleDelete("//", row.appointmentId,)}
              className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Delete appointment"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </div>
      </td>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.title} will removed from App!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </tr>
  );
};

// Appointments Card Component
const AppoinmentCard = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("appointments/" + `${row.appointmentId}`, setIsModalOpen);
  const formattedReminder = row.reminder ? moment(row.reminder).format("DD-MMM-YYYY hh:mm A") : "--";
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-4 sm:p-5 flex flex-col gap-3.5 overflow-hidden border-l-4 border-l-[#048178]">
      {/* Card Header */}
      <div className="flex justify-between items-start gap-3">
        <div className="flex flex-col min-w-0 flex-1">
          <Link
            to={`/marketing/appointments/view/${row.appointmentId}`}
            state={{ data: row, pageIndex, searchQuery }}
            className="text-gray-800 font-bold hover:underline text-sm truncate"
          >
            {row.title || "N/A"}
          </Link>
          <span className="text-[10px] text-gray-400 font-bold mt-0.5">ID: #{row.appointmentId}</span>
        </div>

        {/* Status Badge */}
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border shrink-0 ${row.status === "Completed" || row.status === "Approved"
          ? "bg-emerald-50 text-emerald-700 border-emerald-100"
          : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
          }`}>
          {row.status || "N/A"}
        </span>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/80 rounded-xl p-3 border border-gray-100 flex flex-wrap sm:flex-nowrap justify-between items-center gap-2 text-xs">
        <div className="flex flex-col gap-0.5 flex-1 min-w-[90px]">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Industry</span>
          <span className="font-bold text-gray-700 truncate">{row.industry || "--"}</span>
        </div>
        <div className="hidden sm:block w-[1px] h-7 bg-gray-200/60" />
        <div className="flex flex-col gap-0.5 flex-1 min-w-[90px] pl-0 sm:pl-2">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Purpose</span>
          <span className="font-bold text-gray-700 truncate">{row.visitPurpose || "--"}</span>
        </div>
      </div>

      {/* Reminder Info */}
      <div className="text-[11px] text-gray-500 font-medium px-1 flex justify-between items-center">
        <span>Reminder:</span>
        <span className="font-bold text-gray-700 truncate ml-2">{formattedReminder}</span>
      </div>

      {/* Action Buttons Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center justify-between gap-2 border-t border-gray-100 pt-3 mt-0.5">
        <Link
          to={`/marketing/appointments/view/${row.appointmentId}`}
          state={{ data: row, pageIndex, searchQuery }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View Details
        </Link>
        <div className="flex gap-2 flex-1 sm:flex-none justify-end">
          {CheckEditAction(row, "Appoinment", canEdit) && (
            <Link
              to={`/marketing/appointments/edit/${row.appointmentId}`}
              state={{ data: row, from: "/marketing/appointments", pageIndex, searchQuery }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Edit
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => {
                setIsModalOpen(true);
              }}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-3 py-1.5 rounded-lg transition-all duration-200 flex items-center justify-center gap-1.5 text-xs font-semibold flex-1 sm:flex-none cursor-pointer"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.title} will removed from App!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function AppoinmentIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)
  const [filter, setFilter] = useState(false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(localStorage.getItem("appointmentsViewMode") || "table");
  const { value: Status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Status_Appoinments', showFilterDialog)
  const { value: Industry } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Industry_Appoinments', showFilterDialog)

  const [isMobileScreen, setIsMobileScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobileScreen ? "card" : viewMode;



  const [filterProps, setFilterProps] = useState({
    industry: "",
    holderType: "",
    status: ""
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",
    industry: "",
    holderType: "",
    status: ""
  });
  const clearFilter = () => {
    setParams({
      ...params,
      industry: "",
      holderType: "",
      status: ""
    })
    formik.values.industry = ""
    formik.values.holderType = ""
    formik.values.status = ""

    setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      industry: yup.string(),
      holderType: yup.string(),
      status: yup.string()
    }),
    onSubmit: async (value, { resetForm }) => {
      setParams({ ...params, industry: value.industry, holderType: value.holderType, status: value.status, page: 1 })
      setPage(1)
      closeFilterDialog();
      setFilter(true)
    }
  })

  const { data, totalCount, dataLoading, getData } = UseGetDataSearch("/appointments/", params);

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount])

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const canEdit = GetAccess("appointments_edit") || GetRole();
  const canDelete = GetAccess("appointments_delete") || GetRole();
  const { handle } = useDeleteData(getData);

  return (
    <div className='w-full h-full px-2 sm:px-4 py-2'>
      <div className='w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3'>
        <div className='w-full md:w-auto flex justify-between items-center gap-2'>
          <Breadcrumb items={[
            { name: "Marketing" },
            { name: "Appoinment" },
          ]} />
          <div className='flex md:hidden items-center gap-2'>
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
            {GetAccess("appointments_create") && <Link to="/marketing/appointments/create"><CreateButton label='Appoinment' /></Link>}
          </div>
        </div>

        <div className='w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2'>
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1)
              }}
              value={params.search || searchQuery}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && <FilterButton handleClick={() => clearFilter()} label='Clear' />}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="appointmentsViewMode"
          />

          <div className='hidden md:flex items-center gap-2'>
            {GetAccess("appointments_create") && <Link to="/marketing/appointments/create"><CreateButton label='Appoinment' /></Link>}
          </div>
        </div>
      </div>

      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={effectiveViewMode}
        headers={[
          { title: "ID", width: "70px" },
          { title: "Title", width: "auto" },
          { title: "Industry", width: "140px" },
          { title: "Visit Purpose", width: "150px" },
          { title: "Reminder", width: "170px" },
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "100px" }
        ]}
        renderRow={(row, idx) => (
          <AppoinmentTableRow
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handle}
          />
        )}
        renderCard={(row, idx) => (
          <AppoinmentCard
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handle}
          />
        )}
        dataLoading={dataLoading}
      />

      {showFilterDialog && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-xs z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-[92vw] sm:w-[480px] max-w-full max-h-[85vh] bg-white p-5 sm:p-6 rounded-2xl shadow-2xl overflow-y-auto flex flex-col">
            <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
              <h2 className="text-lg font-bold text-gray-800">Filter Appointment</h2>
              <button
                onClick={closeFilterDialog}
                type="button"
                className="text-gray-400 hover:text-gray-600 p-1 rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={formik.handleSubmit} className="flex flex-col gap-2">
              <div className="flex flex-col gap-1">
                <FormikSelectTwo
                  type="text"
                  label="Industry"
                  placeholder="Choose"
                  Options={Industry}
                  formik={formik}
                  name="industry"
                  width="w-full"
                  px="0"
                />
                <FormikSelectTwo
                  type="text"
                  label="Holder Type"
                  placeholder="Choose"
                  Options={[
                    { value: "Lead", label: "Lead" },
                    { value: "Customer", label: "Customer" },
                  ]}
                  formik={formik}
                  name="holderType"
                  width="w-full"
                  px="0"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={Status}
                  formik={formik}
                  name="status"
                  width="w-full"
                  px="0"
                />
              </div>

              <div className="flex justify-end gap-2.5 pt-4 mt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}


export default AppoinmentIndex;
